import React, {useEffect, useRef, useState} from 'react'
import Select from 'react-select'
import {pays} from '../../../../../components/Data'
import {transformToValueLabel} from '../../../../../components/helpers'

const FinalAdresseClient = (props) => {
  const {
    clientAdresses,
    isAdresseUpdated,
    setIsAdresseUpdated,
    updatedFinalAdresseLivInfo,
    setUpdatedFinalAdresseLivInfo,
    updatedFinalAdresseFactInfo,
    setUpdatedFinalAdresseFactInfo,
    loadingAdresse,
    clientData,
    errorsFac,
    errorsLiv,
    retraitDepot,
    setRetraitDepot,
    setPanier,
    setInitialPieces,
    loadingDepot,
    handleSelectedFactChange = () => {},
    handleSelectedLivChange = () => {},
    setClientAdresses = undefined,
    addressDepotFormat,
    piecePanierFormat,
    associations,
    setAssociations,
    selectedPiece,
    setSelectedPiece,
    selectedDepot,
    setSelectedDepot,
    facturationSelectedValue,
    setFacturationSelectedValue,
    livraisonSelectedValue,
    setLivraisonSelectedValue,
    clientAdresseData
  } = props

  const [showAdresses, setShowAdresses] = useState<boolean>(false)
  const [changePieceDepot, setChangePieceDepot] = useState<boolean>(false)

  const adresseLivraison = clientAdresses?.filter((adresse) => adresse.livraison === true)
  const adresseFacturation = clientAdresses?.filter((adresse) => adresse.facturation === true)

  // Ref pour ne lancer l'initialisation par défaut qu'une seule fois par client
  const initializedForClientLivRef = useRef(null)
  const initializedForClientFactRef = useRef(null)

  const handleAdressLivChange = (e: React.ChangeEvent<HTMLInputElement> | any, field?: string) => {
    if (!setUpdatedFinalAdresseLivInfo) return
    // cas input classique
    if (e?.target) {
      const {name, value} = e.target

      setUpdatedFinalAdresseLivInfo((prev) => ({
        ...prev,
        [name]: value,
        edited: true,
      }))
    }
    // cas react-select
    else if (field) {
      setUpdatedFinalAdresseLivInfo((prev) => ({
        ...prev,
        [field]: e?.label || '',
        edited: true,
      }))
    }
  }

  const handleAdressFactChange = (e: React.ChangeEvent<HTMLInputElement> | any, field?: string) => {
    if (!setUpdatedFinalAdresseFactInfo) return
    // cas input classique
    if (e?.target) {
      const {name, value} = e.target

      setUpdatedFinalAdresseFactInfo((prev) => ({
        ...prev,
        [name]: value,
        edited: true,
      }))
    }
    // cas react-select
    else if (field) {
      setUpdatedFinalAdresseFactInfo((prev) => ({
        ...prev,
        [field]: e?.label || '',
        edited: true,
      }))
    }
  }

  // Donnée à afficher par défaut
  // Fonctionnement:
  // Si le client n'a pas d'adresse Client, prendre les adresses du fiche client
  // Si le client a des adresses dans clientAdresse mais pas d'adresse de facturation ni livraison
  // Alors prendre celui dans Fiche Client
  // Si l'une des deux adresses est absentes dans ClientAdresse
  // Alors prendre celui de la facturation ou de la livraison
  useEffect(() => {
    if (!setUpdatedFinalAdresseFactInfo) return

    if (!clientAdresseData) {
      // Le parent signale un refetch en cours (clientAdresses reset à null) :
      // on autorise une réinitialisation dès que les nouvelles données arrivent
      if (clientAdresses === null) {
        initializedForClientFactRef.current = null
        return // rien à faire tant que les données ne sont pas arrivées
      }

      const clientKey = clientData?.id ?? null

      if (initializedForClientFactRef.current === clientKey) {
        return
      }
      initializedForClientFactRef.current = clientKey
    }

    // Cohérence avec l'effet de livraison : ne pas écraser une saisie utilisateur
    if (updatedFinalAdresseFactInfo?.edited) return

    if (clientAdresses?.length === 0) {
      setUpdatedFinalAdresseFactInfo({
        id: '',
        adresseFac: clientData?.adresse,
        complementAdresseFac: clientData?.complementAdresse || '',
        telephoneFac: clientData?.telephone || '',
        cPFac: clientData?.codePostal || '',
        villeFac: clientData?.ville || '',
        paysFac: clientData?.pays?.nom || '',
      })
      return
    }

    if (adresseFacturation?.length !== 0) {
      //Récuperation de la dernière adresse
      const lastAdresse = (clientAdresseData && clientAdresseData?.facturation)
        ? clientAdresseData
        : adresseFacturation?.at(-1)

      setFacturationSelectedValue(transformToValueLabel(lastAdresse))
      setUpdatedFinalAdresseFactInfo({
        id: lastAdresse?.id || '',
        adresseFac: lastAdresse?.adresse || '',
        complementAdresseFac: lastAdresse?.complementAdresse || '',
        telephoneFac: lastAdresse?.telephone || '',
        cPFac: lastAdresse?.codePostal || '',
        villeFac: lastAdresse?.ville || '',
        paysFac: lastAdresse?.pays?.nom || '',
      })
      return
    }

    if (adresseLivraison?.length === 0) {
      setUpdatedFinalAdresseFactInfo({
        id: '',
        adresseFac: clientData?.adresse,
        complementAdresseFac: clientData?.complementAdresse || '',
        telephoneFac: clientData?.telephone || '',
        cPFac: clientData?.codePostal || '',
        villeFac: clientData?.ville || '',
        paysFac: clientData?.pays?.nom || '',
      })
    } else {
      // Si pas d'adresse de facturation alors prendre celui de la livraison
      // Si avec adresse de livraison alors le mettre dans la facturation
      const lastAdresseLiv = (clientAdresseData?.facturation)
        ? clientAdresseData
        : adresseLivraison?.at(-1)

      setFacturationSelectedValue(transformToValueLabel(lastAdresseLiv))
      setUpdatedFinalAdresseFactInfo({
        id: '',
        adresseFac: lastAdresseLiv?.adresse || '',
        complementAdresseFac: lastAdresseLiv?.complementAdresse || '',
        telephoneFac: lastAdresseLiv?.telephone || '',
        cPFac: lastAdresseLiv?.codePostal || '',
        villeFac: lastAdresseLiv?.ville || '',
        paysFac: lastAdresseLiv?.pays?.nom || '',
      })
    }
  }, [clientAdresses, clientData])

  // Transfromation du donnnée en value/label pour l'option de react-select
  const transformedDataFact = clientAdresses
    ?.filter((adresse) => adresse.facturation === true)
    ?.map((item) => ({
      value: item.id,
      label: item?.libelle ?? item.adresse,
    }))

  // Affichage des données d'adresse de facturation
  const displayFacturationAdresses = () => {
    return (
      <div className='d-flex mb-3 gap-3 align-items-center'>
        <Select
          className='react-select-styled react-select-solid react-select-lg min-w-200px'
          classNamePrefix='react-select'
          fieldName='facturation'
          options={transformedDataFact}
          value={transformedDataFact?.find(
            (item) => item?.label == facturationSelectedValue?.label
          )}
          onChange={(e) => handleSelectedFactChange(e)}
          placeholder='Adresse de facturation'
          isDisabled={adresseFacturation?.length <= 1 ? 'true' : ''}
        />
        <input className={'d-none'} value={updatedFinalAdresseFactInfo?.id} name='id' />
        <input
          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
            errorsFac?.adresseFac ? 'is-invalid' : ''
          }`}
          type={'text'}
          value={updatedFinalAdresseFactInfo?.adresseFac}
          onChange={handleAdressFactChange}
          placeholder={'Adresse'}
          name='adresseFac'
        />
        <input
          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0 '}
          type={'text'}
          value={updatedFinalAdresseFactInfo?.complementAdresseFac}
          onChange={handleAdressFactChange}
          placeholder={'Complément adresse'}
          name='complementAdresseFac'
        />
        <input
          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
            errorsFac?.telephoneFac ? 'is-invalid' : ''
          }`}
          type={'text'}
          value={updatedFinalAdresseFactInfo?.telephoneFac}
          onChange={handleAdressFactChange}
          placeholder={'Téléphone'}
          name='telephoneFac'
        />
        <input
          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
            errorsFac?.cPFac ? 'is-invalid' : ''
          }`}
          type={'text'}
          value={updatedFinalAdresseFactInfo?.cPFac}
          onChange={handleAdressFactChange}
          placeholder={'Code postal'}
          name='cPFac'
        />
        <input
          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
            errorsFac?.villeFac ? 'is-invalid' : ''
          }`}
          type={'text'}
          value={updatedFinalAdresseFactInfo?.villeFac}
          onChange={handleAdressFactChange}
          placeholder={'Ville'}
          name='villeFac'
        />
        <div className={`form-control border-0 ${errorsFac?.paysFac ? 'is-invalid' : ''}`}>
          <Select
            className='react-select-styled react-select-solid react-select-lg'
            classNamePrefix='react-select'
            fieldName='paysFac'
            options={pays}
            value={pays?.find((item) => item.label == updatedFinalAdresseFactInfo?.paysFac)}
            onChange={(option) => handleAdressFactChange(option, 'paysFac')}
            placeholder='Pays'
          />
        </div>
      </div>
    )
  }

  // Donnée à afficher par défaut
  // Fonctionnement:
  // Si le client n'a pas d'adresse Client, prendre les adresses du fiche client
  // Si le client a des adresses dans clientAdresse mais pas d'adresse de facturation ni livraison
  // Alors prendre celui du fiche client
  // Si l'une des deux adresses est absentes dans ClientAdresse
  // Alors prendre celui de la facturation ou de la livraison
  useEffect(() => {
    if (!clientAdresseData) {
      // Le parent signale un refetch en cours (reset explicite) :
      // on doit permettre une réinitialisation dès que les nouvelles données arrivent
      if (clientAdresses === null) {
        initializedForClientLivRef.current = null
        return // rien à faire tant que les données ne sont pas arrivées
      }

      const clientKey = clientData?.id ?? null

      if (initializedForClientLivRef.current === clientKey) {
        return
      }
      initializedForClientLivRef.current = clientKey
    }

    if (updatedFinalAdresseLivInfo?.edited) return
    if (!setUpdatedFinalAdresseLivInfo) return

    if (clientAdresses?.length === 0) {
      setUpdatedFinalAdresseLivInfo({
        id: '',
        adresseLiv: clientData?.adresse,
        complementAdresseLiv: clientData?.complementAdresse || '',
        telephoneLiv: clientData?.telephone || '',
        cPLiv: clientData?.codePostal || '',
        villeLiv: clientData?.ville || '',
        paysLiv: clientData?.pays?.nom || '',
      })
      return
    }

    if (adresseLivraison?.length !== 0) {
      const lastAdresse = (clientAdresseData && clientAdresseData?.livraison)
        ? clientAdresseData
        : adresseLivraison?.at(-1)

      setLivraisonSelectedValue(transformToValueLabel(lastAdresse))
      setUpdatedFinalAdresseLivInfo({
        id: lastAdresse?.id || '',
        adresseLiv: lastAdresse?.adresse || '',
        complementAdresseLiv: lastAdresse?.complementAdresse || '',
        telephoneLiv: lastAdresse?.telephone || '',
        cPLiv: lastAdresse?.codePostal || '',
        villeLiv: lastAdresse?.ville || '',
        paysLiv: lastAdresse?.pays?.nom || '',
      })
      return
    }

    if (adresseFacturation?.length === 0) {
      setUpdatedFinalAdresseLivInfo({
        id: '',
        adresseLiv: clientData?.adresse || '',
        complementAdresseLiv: clientData?.complementAdresse || '',
        telephoneLiv: clientData?.telephone || '',
        cPLiv: clientData?.codePostal || '',
        villeLiv: clientData?.ville || '',
        paysLiv: clientData?.pays?.nom || '',
      })
    } else {
      const lastAdresseFac = (clientAdresseData?.livraison)
        ? clientAdresseData
        : adresseFacturation?.at(-1)

      setLivraisonSelectedValue(transformToValueLabel(lastAdresseFac))
      setUpdatedFinalAdresseLivInfo({
        id: '',
        adresseLiv: lastAdresseFac?.adresse || '',
        complementAdresseLiv: lastAdresseFac?.complementAdresse || '',
        telephoneLiv: lastAdresseFac?.telephone || '',
        cPLiv: lastAdresseFac?.codePostal || '',
        villeLiv: lastAdresseFac?.ville || '',
        paysLiv: lastAdresseFac?.pays?.nom || '',
      })
    }
  }, [clientAdresses, clientData])

  // Transfromation du donnnée en value/label pour l'option de react-select
  const transformedDataLiv = clientAdresses
    ?.filter((adresse) => adresse.livraison === true)
    ?.map((item) => ({
      value: item.id,
      label: item?.libelle ?? item.adresse,
    }))

  const handleChangeRetraitDepot = () => {
    setRetraitDepot(!retraitDepot)
    if (setPanier) {
      setPanier((prev) =>
        prev.map((piece) => {
          if (piece.statut !== 'PROPO' && piece.statut !== 'A_PROPO') return piece
          const pieceExclue = !!clientData?.sauf?.some(
            (item) => item.label === piece.nomTypePieceProposee
          )
          const fraisOffert = !!clientData?.fraisPortOffert && !pieceExclue
          const fraisDePort = fraisOffert || !retraitDepot ? 0 : piece?.fraisDePortInitial ?? 0
          return {
            ...piece,
            fraisDePort: fraisDePort,
          }
        })
      )
      setInitialPieces((initialPieces) => {
        if (initialPieces.statut !== 'PROPO' && initialPieces.statut !== 'A_PROPO')
          return initialPieces
        return initialPieces?.map((item) => ({
          ...item,
          fraisDePort: !retraitDepot ? 0 : item?.fraisDePortInitial,
        }))
      })
    }
  }

  useEffect(() => {
    //initialisation de l'objet association en prenant les valeurs enrégistrer dans la base
    if (!piecePanierFormat?.length) return

    const initialAssociations = {}

    piecePanierFormat.forEach((piece) => {
      if (piece.value === 'tous') return

      initialAssociations[piece.value] = {
        label: piece.label,
        depot: piece.disabled
          ? piece.nomRetraitDepot
          : piece.nomRetraitDepot !== null
          ? piece.nomRetraitDepot
          : selectedDepot?.label,
        depotId: piece.disabled
          ? piece.nomRetraitDepot
          : piece.idRetraitDepot !== null
          ? piece.idRetraitDepot
          : selectedDepot?.value,
        isDisabled: piece.disabled,
      }
    })

    if (retraitDepot) {
      setAssociations(initialAssociations)
      setChangePieceDepot(false)
    }
  }, [piecePanierFormat])

  useEffect(() => {
    //modification dans le cas où le télévendeur change le retrait dépot
    if (!piecePanierFormat?.length || !retraitDepot) return


    if (!changePieceDepot) return

    setAssociations((prev) => {
      const next = {...prev}

      if (selectedPiece.value === 'tous') {
        piecePanierFormat.forEach((piece) => {
          if (piece.value === 'tous') return
          if (!piece.disabled) {
            next[piece.value] = {
              ...next[piece?.value],
              depot: selectedDepot?.label,
              depotId: selectedDepot?.value,
            }
          }
        })
      } else {
        next[selectedPiece.value] = {
          ...next[selectedPiece.value],
          label: selectedPiece?.label,
          depot: selectedDepot?.label,
          depotId: selectedDepot?.value,
        }
      }

      return next
    })
  }, [selectedPiece, selectedDepot])

  // Sync updated livraison address back into clientAdresses par id correspondant
  useEffect(() => {
    if (!setClientAdresses) return
    const info = updatedFinalAdresseLivInfo
    if (!info || !info.id) return

    setClientAdresses((prev) => {
      if (!Array.isArray(prev)) return prev

      let hasChanged = false
      const next = prev.map((addr) => {
        if (String(addr?.id) !== String(info.id)) return addr

        const updated = {
          ...addr,
          adresse: info?.adresseLiv ?? addr?.adresse,
          complementAdresse: info?.complementAdresseLiv ?? addr?.complementAdresse,
          telephone: info?.telephoneLiv ?? addr?.telephone,
          codePostal: info?.cPLiv ?? addr?.codePostal,
          ville: info?.villeLiv ?? addr?.ville,
          pays: {
            ...(addr?.pays || {}),
            nom: info?.paysLiv ?? addr?.pays?.nom,
          },
        }

        // Ne marque un changement que si une valeur diffère réellement
        if (
          updated.adresse !== addr?.adresse ||
          updated.complementAdresse !== addr?.complementAdresse ||
          updated.telephone !== addr?.telephone ||
          updated.codePostal !== addr?.codePostal ||
          updated.ville !== addr?.ville ||
          updated.pays?.nom !== addr?.pays?.nom
        ) {
          hasChanged = true
        }

        return updated
      })

      // Si rien n'a changé, on retourne la même référence pour ne pas
      // redéclencher inutilement le 1er useEffect
      return hasChanged ? next : prev
    })
  }, [updatedFinalAdresseLivInfo])

  // Sync updated facturation address back into clientAdresses by matched id
  useEffect(() => {
    if (!setClientAdresses) return
    const info = updatedFinalAdresseFactInfo
    if (!info || !info.id) return
    setClientAdresses((prev) => {
      if (!Array.isArray(prev)) return prev
      return prev.map((addr) => {
        if (String(addr?.id) !== String(info.id)) return addr
        return {
          ...addr,
          adresse: info?.adresseFac ?? addr?.adresse,
          complementAdresse: info?.complementAdresseFac ?? addr?.complementAdresse,
          telephone: info?.telephoneFac ?? addr?.telephone,
          codePostal: info?.cPFac ?? addr?.codePostal,
          ville: info?.villeFac ?? addr?.ville,
          pays: {
            ...(addr?.pays || {}),
            nom: info?.paysFac ?? addr?.pays?.nom,
          },
        }
      })
    })
  }, [updatedFinalAdresseFactInfo])

  // Affichage des données d'adresse de livraison
  const displayLivraisonAdresses = () => {
    return (
      <div className='d-flex mb-3 gap-3 align-items-center'>
        <Select
          className={`react-select-styled react-select-solid react-select-lg min-w-200px`}
          classNamePrefix='react-select'
          fieldName='livraison'
          options={transformedDataLiv}
          value={transformedDataLiv?.find((item) => item?.label == livraisonSelectedValue?.label)}
          onChange={(e) => handleSelectedLivChange(e)}
          placeholder='Adresse de livraison'
          isDisabled={
            adresseLivraison?.length <= 1 || (retraitDepot !== undefined && retraitDepot)
              ? 'true'
              : ''
          }
        />
        <input className={'d-none'} value={updatedFinalAdresseLivInfo?.id} name='id' />
        <input
          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
            errorsLiv?.adresseLiv ? 'is-invalid' : ''
          }`}
          type={'text'}
          value={updatedFinalAdresseLivInfo?.adresseLiv}
          onChange={handleAdressLivChange}
          placeholder={'Adresse'}
          name='adresseLiv'
          disabled={retraitDepot !== undefined && retraitDepot}
        />
        <input
          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
          type={'text'}
          value={updatedFinalAdresseLivInfo?.complementAdresseLiv}
          onChange={handleAdressLivChange}
          placeholder={'Complément adresse'}
          name='complementAdresseLiv'
          disabled={retraitDepot !== undefined && retraitDepot}
        />
        <input
          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
            errorsLiv?.telephoneLiv ? 'is-invalid' : ''
          }`}
          type={'text'}
          value={updatedFinalAdresseLivInfo?.telephoneLiv}
          onChange={handleAdressLivChange}
          placeholder={'Téléphone'}
          name='telephoneLiv'
          disabled={retraitDepot !== undefined && retraitDepot}
        />
        <input
          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
            errorsLiv?.cPLiv ? 'is-invalid' : ''
          }`}
          type={'text'}
          value={updatedFinalAdresseLivInfo?.cPLiv}
          onChange={handleAdressLivChange}
          placeholder={'Code postal'}
          name='cPLiv'
          disabled={retraitDepot !== undefined && retraitDepot}
        />
        <input
          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
            errorsLiv?.villeLiv ? 'is-invalid' : ''
          }`}
          type={'text'}
          value={updatedFinalAdresseLivInfo?.villeLiv}
          onChange={handleAdressLivChange}
          placeholder={'Ville'}
          name='villeLiv'
          disabled={retraitDepot !== undefined && retraitDepot}
        />
        <div className={`form-control border-0 ${errorsLiv?.paysLiv ? 'is-invalid' : ''}`}>
          <Select
            className='react-select-styled react-select-solid react-select-lg'
            classNamePrefix='react-select'
            fieldName='paysLiv'
            options={pays}
            value={pays?.find((item) => item.label == updatedFinalAdresseLivInfo?.paysLiv)}
            onChange={(option) => handleAdressLivChange(option, 'paysLiv')}
            placeholder='Pays'
            isDisabled={retraitDepot !== undefined && retraitDepot ? 'true' : ''}
          />
        </div>
      </div>
    )
  }

  const displayRetraitChoice = () => {
    return (
      <>
        <div className='d-flex mb-3 gap-3 align-items-center'>
          <Select
            className={`react-select-styled react-select-solid react-select-lg min-w-200px`}
            classNamePrefix='react-select'
            fieldName='piecePanier'
            options={piecePanierFormat}
            value={selectedPiece}
            onChange={(e) => {
              setSelectedPiece(e)
              setChangePieceDepot(true)
            }}
            placeholder='Pièce panier'
            isOptionDisabled={(option) => option.disabled}
          />
          <Select
            className={`react-select-styled react-select-solid react-select-lg min-w-250px`}
            classNamePrefix='react-select'
            fieldName='retrait'
            options={loadingDepot ? 'Chargement en cours...' : addressDepotFormat}
            value={loadingDepot ? 'Chargement en cours...' : selectedDepot}
            onChange={(e) => {
              setSelectedDepot(e)
              setChangePieceDepot(true)
            }}
            placeholder='Sélectionner un dépôt...'
            isDisabled={loadingDepot ? 'true' : ''}
          />
        </div>

        <div className='border rounded mb-3'>
          <div className='card-body row'>
            {Object.entries(associations).map(([id, assoc]: any) => (
              <div key={id} className='col-lg-4 mb-3'>
                <div
                  className='d-grid'
                  style={{
                    gridTemplateColumns: '350px 20px 1fr',
                    alignItems: 'center',
                  }}
                >
                  <span className={` ${assoc.isDisabled ? 'text-secondary' : 'text-primary'} `}>
                    {assoc.label.toLowerCase()}
                  </span>

                  <span className={` text-center ${assoc.isDisabled ? 'text-secondary' : ''} `}>
                    :
                  </span>

                  <span className={` ${assoc.isDisabled ? 'text-secondary' : ''} `}>
                    {assoc.depot ?? 'PL'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <span
        className='d-flex align-items-center mb-1'
        onClick={() => {
          if (loadingAdresse) return
          setShowAdresses(!showAdresses)
        }}
      >
        <hr className='flex-grow-1 text-muted' />
        <div
          className={`d-flex gap-2 text-primary fw-bold fs-6 mx-3 ${
            loadingAdresse ? 'cursor-default' : 'cursor-pointer'
          } align-items-center`}
        >
          Adresse de facturation / livraison{' '}
          {loadingAdresse ? (
            <span className='spinner-border spinner-border-sm align-middle w-13px h-13px'></span>
          ) : showAdresses ? (
            <div className='d-flex align-items-center gap-2'>
              <i className='ki-duotone ki-up'></i>
            </div>
          ) : (
            <div className='d-flex align-items-center gap-2'>
              <i className='ki-duotone ki-down'></i>
            </div>
          )}
        </div>
        <hr className='flex-grow-1 text-muted' />
      </span>
      {showAdresses && (
        <div className={'px-5'}>
          <div className='d-flex flex-column'>
            <div className='mb-1'>
              <h5>Adresse de facturation</h5>
              <div>{displayFacturationAdresses()}</div>
            </div>
            <div className=''>
              <div className='d-flex justify-content-start gap-3 mb-3'>
                <h5
                  className={`cursor-pointer ${!retraitDepot ? 'text-primary' : 'text-gray-400'}`}
                  onClick={() => setRetraitDepot(false)}
                >
                  Adresse de livraison
                </h5>
                <div className='form-check form-switch form-check-custom form-check-solid mt-n2 mx-2'>
                  <input
                    id='retraitDeport'
                    type='checkbox'
                    name='retraitDeport'
                    className='form-check-input h-20px w-35px cursor-pointer'
                    onChange={() => handleChangeRetraitDepot()}
                    checked={retraitDepot}
                  />
                </div>
                <h5
                  className={`cursor-pointer ${retraitDepot ? 'text-primary' : 'text-gray-400'}`}
                  onClick={() => setRetraitDepot(true)}
                >
                  Retrait dépôt demandé par le client
                </h5>
              </div>
              {!retraitDepot ? (
                <div>{displayLivraisonAdresses()}</div>
              ) : (
                <div>{displayRetraitChoice()}</div>
              )}
            </div>
          </div>
          <div className={'d-flex gap-5 justify-content-end align-items-center mt-3'}>
            {loadingDepot && (
              <div className={'d-flex gap-3 align-items-center text-muted'}>
                <span className='spinner-border spinner-border-sm align-middle w-15px h-15px'></span>
                <label className={''}>Chargement des adresses de retrait dépôt</label>
              </div>
            )}
            <div className={'text-end form-check form-check-custom form-check-solid form-check-sm'}>
              <input
                type={'checkbox'}
                className={'form-check-input me-3'}
                name={'checkbox-adresse'}
                id={'checkbox-adresse'}
                onChange={() => setIsAdresseUpdated(!isAdresseUpdated)}
              />
              <label htmlFor='checkbox-adresse' className='form-check-label text-gray-600 fs-6'>
                Mettre à jour les adresses du client
              </label>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default FinalAdresseClient
